<template>
  <div>
    <b-row class="mb-1 mt-1">
      <b-col md="8">
        <b-input-group size="sm">
          <b-form-input v-model="filter" placeholder="Фильтр"></b-form-input>
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''" title="Очистить фильтр" variant="danger">
              <b-icon icon="x-circle-fill"/>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <b-table
        striped hover
        responsive
        small
        selectable
        select-mode="single"
        :items="items"
        :fields="fields"
        :sticky-header="heightTab"
        show-empty
        :filter="filter"
        @filtered="onFiltered"
        @row-selected="rowSelected"
        @row-dblclicked="dblClick"
        empty-text='нет записей'
    >
    </b-table>
    <b-table-simple>
      <b-tfoot>
        <b-tr>
          <b-td colspan="7" variant="secondary" class="text-right">
            Общее количество строк: <b>{{ countRecord }}</b>
          </b-td>
        </b-tr>
      </b-tfoot>
    </b-table-simple>
  </div>
</template>

<script>
export default {
  props: {
    items: [],
    fields: [],
    heightTab: {
      type: String,
      default: "60vh"
    },
  },
  data() {
    return {
      totalRows: 0,
      currentPage: 1,
      filter: ''
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1
    },
    rowSelected(rec) {
      this.$emit('input', rec.id)
    },
    dblClick(rec) {
      this.rowSelected(rec);
      this.$emit("closeForm")
    }
  },
  computed: {
    countRecord: function () {
      return this.items.length;
    }
  }
}

</script>

<style scoped>

</style>
